import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@glu/theming';

import styles from './Card.styles';

const Card = ({ classes, children }) => (
  <div className={classes.root}>
    {children}
  </div>
);

Card.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  children: PropTypes.node.isRequired
};

export default withStyles(styles)(Card);
